function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 7.5H7.5V3H3V7.5ZM9.75 21H14.25V16.5H9.75V21ZM3 21H7.5V16.5H3V21ZM3 14.25H7.5V9.75H3V14.25ZM9.75 14.25H14.25V9.75H9.75V14.25ZM16.5 3V7.5H21V3H16.5ZM9.75 7.5H14.25V3H9.75V7.5ZM16.5 14.25H21V9.75H16.5V14.25ZM16.5 21H21V16.5H16.5V21Z",
  fill: "#8A99A8"
});
const SvgSixDots = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSixDots, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/six-dots.6323008a.svg";
export { ForwardRef as ReactComponent };